import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import { useUser } from 'providers/UserProvider';

const LoggedUserButton = dynamic(() => import('./LoggedUserButton'), {
  ssr: false,
});
const SignUpButton = dynamic(() => import('./SignUpButton'), {
  ssr: false,
});

const UserProfileDropdown = ({ gaEventCategory }) => {
  const { isLoggedIn, loadingLoggedInUser } = useUser();

  return (
    <div className="size-8">
      {!loadingLoggedInUser &&
        (isLoggedIn ? (
          <LoggedUserButton gaEventCategory={gaEventCategory} />
        ) : (
          <SignUpButton gaEventCategory={gaEventCategory} />
        ))}
    </div>
  );
};

UserProfileDropdown.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default UserProfileDropdown;
